import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type GalleryProps = {
    className?: string;
};

const Gallery: FunctionComponent<GalleryProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'gallery'}
            viewBox="0 0 250 250"
        >
            <path d="M83 41v20H48v28H0v146h201v-37h27v-33h22V41H83zm110 56v103.3L127.5 140l-47.8 45.8-14.2-13.6L8 221.8V97h185zM15.6 227l49.6-42.8L79.7 198l48-45.9 65.3 60.1V227H15.6zM221 191h-20V89H55V68h166v123zm23-32h-16V61H89V47h155v112z" />
            <path d="M43.3 157.5c13 0 23.6-10.3 23.6-23s-10.6-23-23.6-23c-13 0-23.6 10.3-23.6 23s10.6 23 23.6 23zm0-37.2c8.1 0 14.7 6.3 14.7 14.1s-6.6 14.1-14.7 14.1-14.7-6.3-14.7-14.1c-.1-7.7 6.5-14.1 14.7-14.1z" />
        </svg>
    );
};
export default Gallery;
